import React, { createContext, useContext, useState, useCallback } from 'react';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0); // Tracks active requests
  const [isLoading, setIsLoading] = useState(false); // Derived state for actual spinner visibility

  // Function to show the spinner
  const showLoading = useCallback(() => {
    setLoadingCount(prevCount => {
      const newCount = prevCount + 1;
      if (newCount === 1) { // Only show if it's the first active request
        setIsLoading(true);
      }
      return newCount;
    });
  }, []);

  // Function to hide the spinner
  const hideLoading = useCallback(() => {
    setLoadingCount(prevCount => {
      const newCount = Math.max(0, prevCount - 1); // Ensure it doesn't go below 0
      if (newCount === 0) { // Only hide if no more active requests
        setIsLoading(false);
      }
      return newCount;
    });
  }, []);

  return (
    <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);